import axios from 'axios'
// axios.defaults.baseURL = '//120.77.1.128:20003/quiz/'
axios.defaults.baseURL = 'https://www.erplus.co/quiz/'
export default {
  login: function (params) {
    return axios.get('https://www.erplus.co/oauth/v2/token?grant_type=password&webflag=1&client_id=2_3t7k61w8zz28wc00w0o0swgo0ko48w08c8csk4ss444os4ccgo&client_secret=6o596th97340soswgw8ssswk8gk8cwoo40c4wwccs4g4wswk8', {params})
  },
  getWebMobileUrl (params) {
    return axios.get('https://www.erplus.co/base/getWebMobileUrl',params)
  },
  veriCodeLogin: function (params) {
    return axios.get(`https://www.erplus.co/oauth/v2/token?grant_type=password&username=${params.phone}&password=${params.veri}%23%23%23PMC%23%23%23${params.midNum}&client_id=2_3t7k61w8zz28wc00w0o0swgo0ko48w08c8csk4ss444os4ccgo&client_secret=6o596th97340soswgw8ssswk8gk8cwoo40c4wwccs4g4wswk8`)
  },
  getUserInfo: function () {
    return axios.get('https://www.erplus.co/api/v1/profile')
  },
  getVideoPlayUrl (params) {
    return axios.get(`https://www.erplus.co/upload/videoPlayUrl`, {params})
  },
  getQuestionDetails: function ({id}) {
    return axios.get('getQuiz', {
      params: {id}
    })
  },
  getImageVerifyCodeBasic: function () {
    return axios.get('https://www.erplus.co/mpsms/getImageVerifyCodeBasic')
  },
  checkImageVerifyCode: function (params) {
    return axios.get('https://www.erplus.co/mpsms/checkImageVerifyCode', {
      params,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    })
  },
  addQuestion: function (data) {
    return axios.post('addQuiz', data)
  },
  uerCancelsQuestion: function (data) {
    return axios.post('cancelQuiz', data)
  },
  evaluateQuizSolution: function (data) {
    return axios.post('evaluateQuizSolution', data)
  },
  userUpdateQuestion: function (data) {
    return axios.post('updateQuiz', data)
  },
  addQuestionMessage: function (data) {
    return axios.post('addQuizMessage', data)
  },
  cancelQuizFeedback: function (data) {
    return axios.post('cancelQuizFeedback', data)
  },
  getHotQuestionPage: function ({currentPage, pageSize}) {
    return axios.get('getHotQuizPage', {
      params: {currentPage, pageSize}
    })
  },
  searchQuestionPage: function ({keyword, currentPage, pageSize}) {
    return axios.get('searchQuizPage', {
      params: {keyword, currentPage, pageSize}
    })
  },
  getClassifyQuestionPage: function ({type, currentPage, pageSize}) {
    return axios.get('getClassifyQuizPage', {
      params: {type, currentPage, pageSize}
    })
  },
  getUserQuestionPage: function ({currentPage, pageSize}) {
    return axios.get('getUserQuizPage', {
      params: {currentPage, pageSize}
    })
  },
  getQuestionMessagePage: function ({quizId, currentPage, pageSize}) {
    return axios.get('getQuizMessagePage', {
      params: {quizId, currentPage, pageSize}
    })
  },
  getUserArchivedQuestionPage: function ({currentPage, pageSize}) {
    return axios.get('getUserArchivedQuizPage', {
      params: {currentPage, pageSize}
    })
  },
  getRelatedQuizPage: function ({id, currentPage, pageSize}) {
    return axios.get('getRelatedQuizPage', {
      params: {id, currentPage, pageSize}
    })
  },
  queryQuizRedPoint: function () {
    return axios.get('queryQuizRedPoint')
  },
  sendMpBespoke: function (data) {
    return axios.post('https://www.plusmoney.cn/feedback/MpBespoke', data)
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api.js